import React, { useState } from 'react';
import { Popup } from 'antd-mobile';
import CloseIcon from '@/images/h5-self-service/close_icon.webp';

interface CreateFolderMethodListProps {
  visible: boolean;
  onClose: () => void;
  onManualCreate: () => void;
  onBaiduPanImport: () => void;
  onMaskClick?: () => void;
  showBaiduPan?: boolean;
}

interface IMethod {
  text: string;
  id: string;
}

const MANUAL = 'manual';
const BAIDU_PAN = 'baiduPan';

const CreateFolderMethodList: React.FC<CreateFolderMethodListProps> = ({
  visible,
  onClose,
  onManualCreate,
  onBaiduPanImport,
  onMaskClick,
  showBaiduPan = true,
}) => {
  const _ListData = [
    { text: '百度网盘导入', id: BAIDU_PAN, isShow: showBaiduPan },
    { text: '手动创建', id: MANUAL, isShow: true },
  ];
  const [curItem, setCurItem] = useState<IMethod>();

  function handleSelect(item: IMethod) {
    setCurItem(item);
    if (item.id === MANUAL) {
      onManualCreate?.();
    }
    if (item.id === BAIDU_PAN) {
      onBaiduPanImport?.();
    }
    onClose();
  }

  return (
    <Popup
      visible={visible}
      onMaskClick={() => {
        onMaskClick?.();
        onClose();
      }}
      onClose={() => {
        onClose();
      }}
      position='bottom'
      bodyStyle={{
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
        minHeight: '265px',
        background: 'linear-gradient(180deg, #FFFEE4 0%, #FFFFFF 37.58%)',
      }}
    >
      {/* 标题 */}
      <div className='flex items-center justify-between px-[16px] mt-[24px]'>
        <div className='w-[16px]'></div>
        <div className='text-[16px] text-[#000000] font-bold'>选择创建方式</div>
        <img
          onClick={onClose}
          src={CloseIcon}
          className='w-[16px] h-[16px]'
          alt=''
        />
      </div>
      <div className='px-[24px] mt-[32px]'>
        {_ListData
          .filter((cur) => cur.isShow)
          .map((item, index) => {
            return (
              <div
                key={index}
                onClick={() => handleSelect(item)}
                className={`h-[64px] rounded-[20px] bg-[#F7F7F7] text-[#333333] flex items-center text-[14px] font-bold pl-[16px] mb-[14px] ${
                  item.id === curItem?.id
                    ? 'bg-[#FFFCE8] border-[3px] border-[#FFDDA3]'
                    : ''
                }`}
              >
                {item.text}
              </div>
            );
          })}
      </div>
    </Popup>
  );
};

export default CreateFolderMethodList; 